'use strict';

class Nav {

  constructor() {
    this.handleFirstLevel();
  }

  handleFirstLevel() {
    $('.menu-item-has-children span').each(function () {
      $(this).bind('click', function (e) {
        if ($(document).width() > 994) {
          e.preventDefault();
          let target = $(this).parent().find('.sub-menu').find('li').first().find('a').attr('href');
          window.location.assign(target);
        }
      });
    });
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./scripts/nav/nav.js